import React from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {Result, Button} from 'antd';
import {ArrowLeftOutlined} from '@ant-design/icons';
import PaymentInformationForm from './PaymentInformationForm';
import {COT_ROLE, DISTRICT_ROLE, SECTIONAL_ROLE, useUserRole} from '../utils/userSessionUtils';

const PaymentInformationPageAsUser = () => {
    const {username: electorKey} = useParams();
    const navigate = useNavigate();
    const userRole = useUserRole();

    if (![DISTRICT_ROLE, COT_ROLE, SECTIONAL_ROLE].includes(userRole)) {
        return (
            <Result
                status="403"
                title="403"
                subTitle="No tienes permiso para ver esta página."
                extra={
                    <Button type="primary" icon={<ArrowLeftOutlined />} onClick={() => navigate('/promotores')}>
                        Regresar
                    </Button>
                }
            />
        );
    }

    return (
        <PaymentInformationForm electorKey={electorKey}/>
    );
};

export default PaymentInformationPageAsUser;
